"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouter = require("react-router");
var R = _interopRequireWildcard(require("ramda"));
var _classnames3 = _interopRequireDefault(require("classnames"));
var _helpers = require("@otpusk/apisearch-toolbox/dist/geo/helpers");
var _selectors = require("@otpusk/apisearch-toolbox/dist/geo/selectors");
var _book = require("../../../../routes/book");
var _price = require("../../../../../helpers/price");
var _hocs = require("../../../../../helpers/hocs");
var _hocs2 = require("../../../hocs");
var _Tooltip = _interopRequireWildcard(require("../../../../ui/Tooltip"));
var _Badge = _interopRequireDefault(require("../../../../ui/Badge"));
var _alert = _interopRequireDefault(require("./icons/alert.svg"));
var _helpers2 = require("./helpers");
var _styles = _interopRequireDefault(require("./styles"));
var _excluded = ["onOpenOfferDetailsModal"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var mapperWithIndex = R.addIndex(R.map);
var Price = function Price(_ref) {
  var className = _ref.className,
    compact = _ref.compact,
    countryID = _ref.countryID,
    currency = _ref.currency,
    departure = _ref.departure,
    isActual = _ref.isActual,
    isHeightPromo = _ref.isHeightPromo,
    isMobile = _ref.isMobile,
    hotelID = _ref.hotelID,
    includes = _ref.includes,
    offerID = _ref.offerID,
    operatorID = _ref.operatorID,
    price = _ref.price,
    promoText = _ref.promoText,
    onClickByPrice = _ref.onClickByPrice;
  var _useTranslation = (0, _reactI18next.useTranslation)(['RESULT_CARD', 'TOUR_OPTIONS']),
    t = _useTranslation.t;
  var operatorSelector = (0, _react.useMemo)(function () {
    return R.partialRight((0, _selectors.getOperator)(), [{
      operatorID: operatorID,
      key: (0, _helpers.generateOperatorKey)(countryID, departure)
    }]);
  }, [countryID, departure, operatorID]);
  var operator = (0, _reactRedux.useSelector)(operatorSelector);
  var badges = (0, _react.useMemo)(function () {
    return R.filter(Boolean, [(0, _helpers2.createPromoBadge)(isHeightPromo, promoText), (0, _helpers2.combineTooltipContent)((0, _helpers2.createMoldovaResidentsBadge)(includes), (0, _helpers2.createGalaDinnerBadge)(includes))]);
  }, [includes, isHeightPromo, promoText]);
  return /*#__PURE__*/_react.default.createElement("a", {
    className: (0, _classnames3.default)(_styles.default.resultTourPrice, className, _defineProperty(_defineProperty(_defineProperty({}, _styles.default.compact, compact), _styles.default.isMobile, isMobile), _styles.default.hasPromo, promoText)),
    href: (0, _reactRouter.generatePath)(_book.book.offer, {
      hotelID: hotelID,
      offerID: offerID
    }),
    onClick: onClickByPrice
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames3.default)(_styles.default.resultTourPriceUah, _defineProperty({}, _styles.default.lineThrough, !isActual))
  }, (0, _price.preparePriceForRender)(price, currency.symbol), isMobile && operator && /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.operatorName
  }, operator.name)), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.resultOperatorWrapper
  }, !isMobile && operator && /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.operatorName
  }, operator.name), mapperWithIndex(function (badge, index) {
    return /*#__PURE__*/_react.default.createElement(_Badge.default, _extends({
      compact: compact,
      key: index
    }, badge));
  }, badges)), !isActual && (compact ? /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    content: t('PRICE_NOT_ACTUAL_TOOLTIP_TEXT'),
    placement: _Tooltip.PLACEMENTS.TOP,
    trigger: [_Tooltip.TRIGGERS.HOVER]
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.resultTourAlert
  }, /*#__PURE__*/_react.default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: _alert.default
    }
  }))) : /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.resultTourAlert
  }, /*#__PURE__*/_react.default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: _alert.default
    }
  }), t('PRICE_NOT_ACTUAL_TOOLTIP_TEXT'))));
};
Price.propTypes = {
  countryID: _propTypes.default.number.isRequired,
  currency: _propTypes.default.shape({
    symbol: _propTypes.default.string.isRequired
  }).isRequired,
  departure: _propTypes.default.number.isRequired,
  hotelID: _propTypes.default.number.isRequired,
  offerID: _propTypes.default.string.isRequired,
  price: _propTypes.default.number.isRequired,
  includes: _propTypes.default.array,
  isActual: _propTypes.default.bool,
  isHeightPromo: _propTypes.default.bool,
  isMobile: _propTypes.default.bool,
  operatorID: _propTypes.default.number,
  promoText: _propTypes.default.string,
  onClickByPrice: _propTypes.default.func
};
Price.defaultProps = {
  isActual: true,
  includes: []
};
var enhancer = R.compose(_hocs2.withOpenOfferDetailsHandler, (0, _hocs.withMapProps)(function (_ref2) {
  var onClickByPrice = _ref2.onOpenOfferDetailsModal,
    props = _objectWithoutProperties(_ref2, _excluded);
  return R.mergeAll([props, {
    onClickByPrice: onClickByPrice
  }]);
}), _react.memo);
var _default = exports.default = enhancer(Price);